import React, { createContext, useContext, useReducer } from 'react';

const SearchContext = createContext();

const searchReducer = (state, action) => {
  switch (action.type) {
    case 'NEW_SEARCH':
      return action.payload;
    case 'RESET_SEARCH':
      return { city: '', checkIn: null, checkOut: null, adults: 1, children: 0, rooms: 1 };
    default:
      return state;
  }
};

const initialState = {
  city: '',
  checkIn: new Date(),
  checkOut: new Date(new Date().setDate(new Date().getDate() + 2)),
  adults: 2,
  children: 0,
  rooms: 1
};

export const SearchProvider = ({ children }) => {
  const [searchState, dispatch] = useReducer(searchReducer, initialState);
  return (
    <SearchContext.Provider value={{ searchState, dispatch }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) throw new Error('useSearch must be used within SearchProvider');
  return context;
};
